import { AccordionSummary } from '@mui/material';
import { BaseAccordionSummaryProps } from './BaseAccordionSummary.types';

/**
 * The base control for the Accordion Summary from MUI that we wrap off of.
 *
 * @param id - {@link BaseAccordionSummaryProps.id id} description.
 * @param ariaExpanded - {@link BaseAccordionSummaryProps.ariaExpanded ariaExpanded} description.
 * @param ariaControls - {@link BaseAccordionSummaryProps.ariaControls ariaControls} description.
 * @param classes - {@link BaseAccordionSummaryProps.classes classes} description.
 * @param onClick - {@link BaseAccordionSummaryProps.onClick onClick} description.
 * @param children - {@link BaseAccordionSummaryProps.children children} description.
 */
export const BaseAccordionSummary = ({
    id,
    ariaExpanded,
    ariaControls,
    classes,
    onClick,
    children,
}: BaseAccordionSummaryProps) => {
    return (
        <AccordionSummary
            id={id}
            aria-expanded={ariaExpanded}
            aria-controls={ariaControls}
            classes={classes}
            onClick={onClick}
        >
            {children}
        </AccordionSummary>
    );
};